/*LIBRARY*/
import { Component, createRef } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import TEXT_AREA_CHAT from "./TEXT_AREA_CHAT";
import MARKDOWN_RENDERER from "./MARKDOWN_RENDERER";

/*REDUX*/
import {
  set_value_sini,
  get_ai_child_list,
  get_ai_parent_object,
  get_ai_parent_status,
} from "../../App/actions/sini_v2";
import { post_ai_chat } from "../../App/actions/post_ai_chat";

/*PICTURE*/
import expand from "../../Assets/svg/expand.svg";
import ICON_BACK from "../../Assets/jsx/ICON_BACK";

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

class SINI_CHAT_FULL extends Component {
  state = {
    content_render: null,
  };

  // Create a ref for the scroll container
  scrollContainerRef = createRef();

  componentDidMount() {
    const { request_id_active, ai_parent_child_list, ai_parent_detail_list } =
      this.props.sini;
    const params = {
      request_id: request_id_active,
    };
    this.props.get_ai_parent_status(params);
    const ai_child_list =
      ai_parent_child_list.find(
        (item) => item?.request_id === request_id_active
      )?.ai_child_list || [];
    const sini_db_object_test = ai_parent_detail_list.find(
      (item) => item.request_id === request_id_active
    )?.request_id;
    if (ai_child_list.length === 0) {
      this.props.get_ai_child_list(params);
    }
    if (!sini_db_object_test) {
      this.props.get_ai_parent_object(params);
    }
  }

  toggle_ai_page = () => {
    this.props.set_value_sini({
      key: "modal_ai_page",
      value: !this.props.sini.modal_ai_page,
    });
    this.props.set_value_sini({
      key: "sini_menu_active",
      value: "",
    });
  };

  on_set_sini_menu_active = () => {
    this.props.set_value_sini({
      key: "sini_menu_active",
      value: "",
    });
    this.props.set_value_sini({
      key: "sini_map_show",
      value: ["poi", "isochrone"],
    });
  };

  on_scroll_down = () => {
    if (this.scrollContainerRef.current) {
      this.scrollContainerRef.current.scrollTop =
        this.scrollContainerRef.current.scrollHeight;
    }
  };

  on_post_ai_chat = () => {
    const {
      sini_v2_list,
      request_id_active,
      user_message,
      ai_parent_detail_list,
    } = this.props.sini;
    const merge_array = [...sini_v2_list, ...ai_parent_detail_list];
    const sini_object = merge_array.find(
      (item) => item.request_id === request_id_active
    );
    const body = {
      request_id: request_id_active,
      user_message,
      sini_object,
    };
    this.props.post_ai_chat(body);
    this.props.set_value_sini({
      key: "user_message",
      value: "",
    });
    this.props.set_value_sini({
      key: "rows_text_area",
      value: 1,
    });
    this.on_scroll_down();
  };

  render() {
    //local storage
    const language = localStorage?.language || this.props.auth.language;

    //local state

    //global props
    const { request_id_active, ai_parent_child_list } = this.props.sini;
    const { loading_item_array } = this.props.loading_reducer;

    //content
    const ai_child_list =
      ai_parent_child_list.find(
        (item) => item?.request_id === request_id_active
      )?.ai_child_list || [];

    return (
      <main className="sini_full_parent">
        <section className="sini_full_header">
          <table className="full_width">
            <tbody>
              <tr>
                <td
                  style={{ width: "30px" }}
                  onClick={this.on_set_sini_menu_active}
                >
                  <ICON_BACK />
                </td>
                <td className="text_left">
                  <p className="badge background_grey_light margin_bottom">
                    SINI AI
                  </p>
                </td>
                <td className="text_right">
                  <img
                    className="cursor_pointer"
                    alt="expand"
                    src={expand}
                    style={{ height: "20px" }}
                    onClick={this.toggle_ai_page}
                    data-mapid="clickExpand"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </section>

        <section
          className="sini_full_scroll_area"
          ref={this.scrollContainerRef}
        >
          <section className="container margin_bottom background_black text_medium">
            {dict?.["Explore your business ideas with SINI AI!"]?.[language]}
            <br />
            <br />
            {
              dict?.[
                "Find a variety of important information to support business decisions."
              ]?.[language]
            }
            <br />
            <br />
            <ol>
              <li>
                {
                  dict?.["Land prices in the location you are targeting"]?.[
                    language
                  ]
                }
              </li>
              <li>
                {
                  dict?.["Potential location for business development"]?.[
                    language
                  ]
                }
              </li>
              <li>
                {
                  dict?.[
                    "Characteristics of the area and surrounding environment spatially"
                  ]?.[language]
                }
              </li>
              <li>
                {
                  dict?.["Property insights around your chosen location"]?.[
                    language
                  ]
                }
              </li>
              <li>
                {
                  dict?.[
                    "Disaster risk information at the destination location"
                  ]?.[language]
                }
              </li>
            </ol>
          </section>
          {ai_child_list.map((item, idx) => {
            let final_content;
            if (item.role === "assistant" && item.content) {
              final_content = (
                <section key={idx} id={`ai_sini_${idx}`}>
                  <div className="container margin_bottom background_black text_medium">
                    <MARKDOWN_RENDERER markdownContent={item.content} />
                  </div>
                </section>
              );
            } else {
              final_content = (
                <section key={idx} id={`ai_sini_${idx}`}>
                  <div
                    className="container margin_bottom max_width_300 background_grey_light text_medium"
                    style={{ right: 0, whiteSpace: "pre-wrap" }}
                  >
                    {item.content}
                  </div>
                </section>
              );
            }

            return final_content;
          })}
          {loading_item_array.includes("post_ai_chat") && (
            <main>
              <div className="sini_container_animation">
                <div className="sini_shape_animation sini_circle_1"></div>
                <div className="sini_shape_animation sini_circle_2"></div>
                <div className="sini_shape_animation sini_circle_3"></div>
              </div>

              <br />
              <div
                className={`container_light outline_transparent margin_bottom background_grey`}
              >
                {dict?.["SINI AI is answering"]?.[language]}...
              </div>
            </main>
          )}
        </section>

        <section
          style={{
            position: "absolute",
            bottom: "0px",
            left: 0,
            right: 0,
            paddingBottom: "10px",
            paddingTop: "6px",
            paddingLeft: "5px",
            paddingRight: "5px",
            backgroundColor: "rgba(199,206,214, 0.5)",
            backdropFilter: "blur(10px)",
            WebkitBackdropFilter: "blur(10px)",
            boxSizing: "border-box",
            maxWidth: "100%",
            transform: "translateZ(0)",
          }}
        >
          <TEXT_AREA_CHAT
            scrollContainerRef={this.scrollContainerRef}
            on_scroll_down={this.on_scroll_down}
          />
        </section>
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  sini: state.sini,
  loading_reducer: state.loading_reducer,
});

export default connect(mapStateToProps, {
  set_value_sini,
  post_ai_chat,
  get_ai_child_list,
  get_ai_parent_object,
  get_ai_parent_status,
})(SINI_CHAT_FULL);
